/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { AppState } from 'src/app/store/app.reducer';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { Observable, Subscription } from 'rxjs';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardDynamicComponent, StandardNewValidator, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { selectMtmaSpecialPlanningModify } from 'src/app/store/device/device.selector';
import moment from 'moment';
import { MtmaTimeslice } from 'src/app/model/mtma-rules-access';
import { SPECIALPLANNINGS_FLAGS_ACCESS_EXCLUDED, SPECIALPLANNINGS_FLAGS_ACCESS_INCLUDED } from 'src/app/conf/mtma-rules-access';
import { PERMISSION_DEFAULT_START } from 'src/app/conf/permissions';

@Component({
	selector: 'app-mtma-control-access-special-planning-dialog',
	templateUrl: './mtma-control-access-special-planning-dialog.component.html',
})

export class MtmaControlAccessSpecialPlanningDialogComponent implements OnInit, OnDestroy {
	specialPlanningModify$: Observable<boolean | undefined>;
	specialPlanningModifySub: Subscription | undefined;

	specialPlanning: MtmaTimeslice;
	editMode = false;

	specialPlanningForm: FormGroup;

	editedSub: Subscription;
	addedSub: Subscription;
	groupModifySub: Subscription;

	minStartDate: Date;
	minEndDate: Date;

	// design
	screenWidth: number;

	constructor(
		private fb: FormBuilder,
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
	) {
		this.specialPlanning = new MtmaTimeslice();
		if (config.data !== undefined && config.data.specialPlanning !== undefined) {
			this.editMode = true;
			this.specialPlanning.Id = config.data.specialPlanning.Id;
			this.specialPlanning.DtFrom = config.data.specialPlanning.DtFrom;
			this.specialPlanning.DtTo = config.data.specialPlanning.DtTo;
			this.specialPlanning.Name = config.data.specialPlanning.Name;
			this.specialPlanning.Flags = config.data.specialPlanning.Flags;
			// set minDates selection possibile based to old saves
			const dtFromDate = new Date(this.specialPlanning.DtFrom);
			const dtToDate = new Date(this.specialPlanning.DtTo);
			if (dtFromDate < PERMISSION_DEFAULT_START) { // edit DtFrom is before today
				this.minStartDate = new Date(this.specialPlanning.DtFrom);
			} else { // edit DtFrom is after today
				this.minStartDate = PERMISSION_DEFAULT_START; // minStartSpecialPlanningAdd = today
			}
			if (dtToDate < PERMISSION_DEFAULT_START) { // edit DtTo is before today
				this.minEndDate = new Date(new Date(this.specialPlanning.DtTo).setHours(0, 0, 0, 0)); // set minEndDate to 00:00:00 because we need to be able to select all endDate day
			} else { // edit DtFrom is after today
				this.minEndDate = PERMISSION_DEFAULT_START; // minEndSpecialPlanningAdd = today
			}
		} else {
			this.specialPlanning.DtFrom = moment().format('yyyy-MM-DDT00:00');
			this.specialPlanning.DtTo = moment().format('yyyy-MM-DDT23:59');
			this.minStartDate = PERMISSION_DEFAULT_START; // minStartSpecialPlanningAdd = today
			this.minEndDate = PERMISSION_DEFAULT_START; // minEndSpecialPlanningAdd = today
			this.specialPlanning.Flags = 0;
		}
		this.initSelectors();
	}

	initSelectors(): void {
		this.specialPlanningModify$ = this.store.select(selectMtmaSpecialPlanningModify);
	}

	ngOnInit(): void {
		this.specialPlanningForm = this.fb.group({
			'Name': new FormControl(this.specialPlanning.Name, [Validators.required, Validators.maxLength(48)]),
			'startDate': new FormControl(moment(this.specialPlanning.DtFrom.split('T')[0]).toDate(), Validators.required),
			'startTime': new FormControl(this.specialPlanning.DtFrom.split('T')[1], Validators.required),
			'endDate': new FormControl(moment(this.specialPlanning.DtTo.split('T')[0]).toDate(), Validators.required),
			'endTime': new FormControl(this.specialPlanning.DtTo.split('T')[1], Validators.required),
			'access': new FormControl(this.isAccessSpecialPlanning(this.specialPlanning)),
		});

		this.subscribeAll();

		this.onResize();
		StandardNewValidator.setFirstCompile(true);
	}

	isAccessSpecialPlanning(specialPlanning: MtmaTimeslice): boolean {
		if ((specialPlanning.Flags & (1 << 0)) > 0) {
			return true;
		}
		return false;
	}

	subscribeAll(): void {
		this.specialPlanningModifySub = this.specialPlanningModify$
			.pipe(filter(specialPlanningModify => !!specialPlanningModify))
			.subscribe(() => {
				this.resetClose();
			});
	}

	ngOnDestroy(): void {
		this.specialPlanningModifySub?.unsubscribe();
	}

	resetClose(): void {
		this.store.dispatch(DeviceActions.resetMtmaSpecialPlanningForm());
		this.closeDialog();
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.specialPlanningForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.specialPlanningForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}
	/*save() {
		let valueFlag = 0;
		if (parseInt(this.f.repetition.value) !== 0 && timeslice.Type === 2) {
			valueFlag = 2 ** this.f.repetition.value;
		}
		if (parseInt(this.f.includeExclude.value) !== 0) {
			valueFlag = valueFlag + 1;
		}
		if (parseInt(this.f.temporary.value) === 1) {
			valueFlag = valueFlag + 2 ** Flag.TEMPORARY;
		}
		if (timeslice.Type === 1) {
			timeslice.Weekdays = this.parseDays();
		} else {
			timeslice.Weekdays = 0;
		}

		let startTimeStr = this.f.startTime.value.toString().toLowerCase()
		if (!/^\d$/.test(startTimeStr.charAt(0))) {
			// non è in formato numerico
			startTimeStr = startTimeStr.substring(16, 21)
			this.f.startTime.value = startTimeStr;
		}

		let endTimeStr = this.f.endTime.value.toString().toLowerCase()
		if (!/^\d$/.test(endTimeStr.charAt(0))) {
			// non è in formato numerico
			endTimeStr = endTimeStr.substring(16, 21)
			this.f.endTime.value = endTimeStr;
		}

		const momTimeFrom = moment().local()
			.hours(+this.f.startTime.value.split(':')[0])
			.minutes(+this.f.startTime.value.split(':')[1]);
		const momTimeTo = moment().local()
			.hours(+this.f.endTime.value.split(':')[0])
			.minutes(+this.f.endTime.value.split(':')[1]);
		const momDateFrom = moment(this.f.startDate.value);
		const momDateTo = moment(this.f.endDate.value);

		//DATE VAL

		if (timeslice.Type === 2 && parseInt(this.f.repetition.value) === Flag.REPETITION_MONTHLY) {
			// PERIODO SPECIALE e RIPETIZIONE MENSILE
			//Set bitmask Flag, 29-30-31
			if (this.f.dayMonthStart.value > 28) {
				switch (this.f.dayMonthStart.value) {
					case 29:
						valueFlag = valueFlag + 2 ** Flag.DATE_29;
						break;
					case 30:
						valueFlag = valueFlag + 2 ** Flag.DATE_30;
						break;
					case 31:
						valueFlag = valueFlag + 2 ** Flag.DATE_31;
						break;
				}
			}
			if (momDateFrom.daysInMonth() >= this.f.dayMonthStart.value) {
				momDateFrom.set('date', this.f.dayMonthStart.value);
			} else {
				momDateFrom.set('date', momDateFrom.daysInMonth());
			}
			//Set bitmask Flag, 29-30-31
			if (this.f.dayMonthEnd.value > 28) {
				switch (this.f.dayMonthEnd.value) {
					case 29:
						valueFlag = valueFlag + 2 ** Flag.DATE_29;
						break;
					case 30:
						valueFlag = valueFlag + 2 ** Flag.DATE_30;
						break;
					case 31:
						valueFlag = valueFlag + 2 ** Flag.DATE_31;
						break;
				}
			}
			if (momDateTo.daysInMonth() >= this.f.dayMonthEnd.value) {
				momDateTo.set('date', this.f.dayMonthEnd.value);
			} else {
				momDateTo.set('date', momDateTo.daysInMonth());
			}
		}
		timeslice.Flags = valueFlag;

		//DATE VAL

	}*/

	save(): void {
		const specialPlanning = { ...this.specialPlanning };
		specialPlanning.Name = this.f.Name.value;
		specialPlanning.Type = 2

		// DATE TIME START ELABORATION
		let startTimeStr = this.f.startTime.value.toString().toLowerCase()
		if (!/^\d$/.test(startTimeStr.charAt(0))) {
			// non è in formato numerico
			startTimeStr = startTimeStr.substring(16, 21)
			this.f.startTime.value = startTimeStr;
		}
		const momDateFrom = moment(this.f.startDate.value);
		const momTimeFrom = moment().local()
			.hours(+this.f.startTime.value.split(':')[0])
			.minutes(+this.f.startTime.value.split(':')[1]);
		specialPlanning.DtFrom = momDateFrom.format('yyyy-MM-DD') + momTimeFrom.format('THH:mm');
		// DATE TIME START ELABORATION
		// DATE TIME END ELABORATION
		let endTimeStr = this.f.endTime.value.toString().toLowerCase()
		if (!/^\d$/.test(endTimeStr.charAt(0))) {
			// non è in formato numerico
			endTimeStr = endTimeStr.substring(16, 21)
			this.f.endTime.value = endTimeStr;
		}
		const momTimeTo = moment().local()
			.hours(+this.f.endTime.value.split(':')[0])
			.minutes(+this.f.endTime.value.split(':')[1]);
		const momDateTo = moment(this.f.endDate.value);
		specialPlanning.DtTo = momDateTo.format('yyyy-MM-DD') + momTimeTo.format('THH:mm');
		// DATE TIME END ELABORATION
		specialPlanning.Flags = this.f.access.value ? SPECIALPLANNINGS_FLAGS_ACCESS_INCLUDED : SPECIALPLANNINGS_FLAGS_ACCESS_EXCLUDED;

		specialPlanning.Weekdays = 0;
		if (this.specialPlanning.Id) {
			this.store.dispatch(DeviceActions.editMtmaSpecialPlanning({ specialPlanning: specialPlanning }));
		} else {
			this.store.dispatch(DeviceActions.addMtmaSpecialPlanning({ specialPlanning: specialPlanning }));
		}
	}


	get f(): any {
		return this.specialPlanningForm.controls;
	}

	closeDialog(): void {
		this.ref.close();
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-20rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: MtmaControlAccessSpecialPlanningDialogComponent["f"], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: MtmaControlAccessSpecialPlanningDialogComponent["f"]): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	dynamicDatepicker(): string {
		return StandardDynamicComponent.dynamicDatepicker(this.screenWidth);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}

	col12Responsive(): string {
		return StandardPageLayout.col6Responsive(this.screenWidth);
	}

	dynamicInputShortTextWidth(): string {
		return StandardPageLayout.dynamicInputTextDesktopTabletWidth(this.screenWidth, 'w-20rem', 'w-30rem');
	}
}
